import { FunctionComponent, useCallback } from 'react';
import {
    Table,
    Thead,
    Tbody,
    Tr,
    Th,
    Td,
    TableCaption,
    useMediaQuery,
} from '@chakra-ui/react';
import { gweiToEth, truncateStringByWidth } from '../../imports/utils';

export type TransactionListProps = {
    transactions: Array<any>;
    caption?: string;
    onSelect?: (tx: any) => void;
};

const TransactionList: FunctionComponent<TransactionListProps> = ({
    transactions,
    onSelect,
    caption,
}) => {
    const handleSelect = useCallback(
        tx => (onSelect ? onSelect(tx) : null),
        [],
    );

    const [isLargerThanHD] = useMediaQuery(['(min-width: 1000px)']);

    return (
        <Table variant='simple' style={{ fontSize: 12 }}>
            {caption && <TableCaption>{caption}</TableCaption>}
            <Thead>
                {transactions.length ? (
                    <Tr>
                        <Th>Blocco</Th>
                        <Th>Destinatario</Th>
                    </Tr>
                ) : null}
            </Thead>
            <Tbody>
                {transactions.map(tx => {
                    return (
                        <Tr onClick={() => handleSelect(tx)}>
                            <Td>{tx.receipt?.blockNumber || ''}</Td>
                            <Td>
                                {isLargerThanHD
                                    ? tx.to
                                    : truncateStringByWidth(tx.to, 400)}
                            </Td>
                        </Tr>
                    );
                })}

                {transactions.length === 0 &&
                    'Non ci sono transazioni in corso'}
            </Tbody>
        </Table>
    );
};

export default TransactionList;
